import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { v4 } from 'uuid';
import { Box, Typography, IconButton, } from '@mui/material';
import X from '@mui/icons-material/X';
import Twitter from '@mui/icons-material/Twitter';
import Instagram from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import Facebook from '../../portal/icons/Facebook';
import PlaceHolder from '../../portal/common/PlaceHolder';
import linkNavigator from '../../portal/common/linkNavigator';
const Title = ({ text }) => (_jsx(Typography, { className: "footerHeading", children: text }));
const navigateToSite = (link) => {
    // Navigate to a new website or URL
    window.location.assign(link);
};
const ListItemLink = (props) => {
    const { primary, editData, } = props;
    if (!primary.active || primary.url === '') {
        return null;
    }
    const sx = {
        color: (t) => t.portal.footer?.socialLinks?.color,
    };
    const renderIcon = (platform) => {
        if (platform === 'Facebook') {
            return (_jsx(Facebook, { sx: sx }));
        }
        if (platform === 'Instagram') {
            return (_jsx(Instagram, { sx: sx }));
        }
        if (platform === 'Twitter') {
            return (_jsx(Twitter, { sx: sx }));
        }
        if (platform === 'X') {
            return (_jsx(X, { sx: sx }));
        }
        if (platform === 'LinkedIn') {
            return (_jsx(LinkedInIcon, { sx: sx }));
        }
        if (platform === 'Youtube') {
            return (_jsx(YouTubeIcon, { sx: sx }));
        }
        return null;
    };
    return (_jsx(Box, { style: {
            marginTop: '6px',
            marginBottom: '6px',
            display: 'inline-block',
        }, children: _jsx(IconButton, { sx: { color: (theme) => theme.palette.indigoCustom[700], mx: 1 }, onClick: (ev) => {
                linkNavigator({ ...primary, type: 'social' }, editData ? (link) => editData.preNavigationHook(link, ev) : navigateToSite);
            }, children: renderIcon(primary.platform) }) }));
};
ListItemLink.defaultProps = {
    primary: undefined,
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SocialLinksWidget = ({ link, editData, limitToPageWidth, }) => {
    const isEmpty = () => {
        let isLinksEmpty = true;
        for (let i = 0; i < link.links.length; i += 1) {
            if (link.links[i].url) {
                isLinksEmpty = false;
            }
        }
        return link.title === '' && isLinksEmpty && editData;
    };
    if (isEmpty()) {
        return (_jsx(PlaceHolder, { placeHolderName: "Configure Social Links Widget" }));
    }
    return (_jsx(Box, { sx: {
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
                width: '100%',
            }),
        }, children: _jsxs(Box, { sx: { width: '100%', mt: { lg: 0 } }, children: [link && _jsx(Title, { text: link.title }), link && link.links && link.links.map((subItem) => (_jsx(React.Fragment, { children: _jsx(ListItemLink, { primary: subItem, editData: editData }) }, subItem.id)))] }) }));
};
SocialLinksWidget.meta = {
    group: 'portal',
    name: 'Social Links',
    description: 'Display a list of links.',
    props: [
        {
            key: 'link',
            name: 'Links',
            type: 'socialLinkList',
            description: 'Social links.',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'SocialLinksWidget',
        props: {
            limitToPageWidth: true,
            link: {
                title: '',
                links: [
                    {
                        id: v4(),
                        platform: 'Facebook',
                        url: '',
                    },
                    {
                        id: v4(),
                        platform: 'Instagram',
                        url: '',
                    },
                    {
                        id: v4(),
                        platform: 'X',
                        url: '',
                    },
                    {
                        id: v4(),
                        platform: 'LinkedIn',
                        url: '',
                    },
                    {
                        id: v4(),
                        platform: 'Youtube',
                        url: '',
                    },
                ],
            },
        },
    },
};
export default SocialLinksWidget;
//# sourceMappingURL=SocialLinksWidget.js.map